/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { OrgUrlParams } from 'types/route';
import logger from './logger';
import { ORG_PATH, PE_PATH } from './route';

export const useOrgHandleChanged = (currentOrgHandle?: string): boolean => {
  const orgHandle = sessionStorage.getItem('orgHandle');

  useEffect(() => {
    if (currentOrgHandle && orgHandle !== currentOrgHandle) {
      sessionStorage.setItem('orgHandle', currentOrgHandle);
    }
  }, [currentOrgHandle]);

  return !!currentOrgHandle && !!orgHandle && orgHandle !== currentOrgHandle;
};

export const useSelectedOrgHandleFromUrl = () => {
  const orgRouteMatch = useRouteMatch<OrgUrlParams>(ORG_PATH);
  const peRouteMatch = useRouteMatch<OrgUrlParams>(PE_PATH);
  const { orgHandle } = orgRouteMatch?.params || peRouteMatch?.params || {};
  if (!orgHandle && process.env.NODE_ENV === 'development') {
    logger.warn('No organization handle found');
  }
  return orgHandle;
};
